import React from 'react';
import { WrappedCard } from '../WrappedCard';
import { WrappedImage } from '../WrappedImage';

interface DaisyCategoryCardProps {
  username: string;
}

interface DaisyCategory {
  label: string;
  image: string;
}

export function getDaisyCategory(username: string): DaisyCategory {
  const normalized = username.toLowerCase().trim();
  
  if (normalized.includes('melathon') || normalized.includes('heelistriker') || normalized.includes('heeli')) {
    return {
      label: 'Daised',
      image: '/daisy_confused.png',
    };
  }
  
  if (normalized.includes('kat')) {
    return {
      label: 'Got Milk',
      image: '/wingate1.jpg',
    };
  }
  
  if (normalized.includes('trimbawolf')) {
    return {
      label: 'AV Club',
      image: '/daisy_avclub.png',
    };
  }
  
  if (normalized.includes('el apagón') || normalized.includes('el_apagon') || normalized.includes('elapagon') || 
      normalized.includes('ernest j') || normalized.includes('ernest_j') || normalized.includes('ernestj')) {
    return {
      label: 'NYCHM',
      image: '/daisy_nychm.png',
    };
  }
  
  if (normalized.includes('madminer') || normalized.includes('mad_miner') || normalized.includes('scar')) {
    return {
      label: 'That DAWG In You',
      image: '/daisy_and_dogs.png',
    };
  }
  
  if (normalized.includes('coach_2') || normalized.includes('coach2')) {
    return {
      label: 'Classic',
      image: '/daisy_wingate.png',
    };
  }
  
  // Default
  return {
    label: 'Come on Over',
    image: '/daisy_christina.png',
  };
}

export const DaisyCategoryCard: React.FC<DaisyCategoryCardProps> = ({ username }) => {
  const category = getDaisyCategory(username);
  
  return (
    <WrappedCard className="relative" username={username}>
      <div className="space-y-4 md:space-y-6 relative z-10">
        {/* Large Daisy category image */}
        <div className="flex justify-center mb-4 md:mb-6">
          <div className="w-full max-w-xs md:max-w-sm">
            <WrappedImage
              src={category.image}
              alt={`DAISY - ${category.label}`}
              fallbackSrc="/daisy_christina.png"
              className="w-full h-auto rounded-2xl border-4 border-yellow-400 shadow-2xl object-cover"
              style={{ maxHeight: '300px', objectFit: 'cover' }}
              maxHeight="300px"
            />
          </div>
        </div>
        
        <div className="bg-black/60 backdrop-blur-md rounded-2xl p-5 md:p-6 border-2 border-yellow-400/50 shadow-2xl mb-3 md:mb-4">
          <p className="text-base md:text-lg lg:text-xl text-yellow-200 font-semibold text-center">
            DAISY Designation
          </p>
        </div>
        
        <div className="text-4xl md:text-5xl lg:text-6xl font-bold bg-gradient-to-r from-yellow-300 via-yellow-200 to-amber-200 bg-clip-text text-transparent drop-shadow-2xl px-2 break-words text-center">
          {category.label}
        </div>
      </div>
    </WrappedCard>
  );
};

